import React, { useState, useEffect, Suspense } from 'react';
import Loading from 'components/Loading';
import styled from 'styled-components';
import { api } from 'app';
import moment from 'moment-jalali';

const Title = styled.strong`
  font-size: 15px;
`;

const Value = styled.span`
  font-size: 14px;
`;

function Statistics({ virgoolId }) {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(true);

  const fetchVirgoolAdData = async () => {
    if (virgoolId !== 'create') {
      api.get(`/virgool-advertises/${virgoolId}/statistics`).then(res => {
        setData([
          { title: 'عنوان', value: res.body.data.name },
          { title: 'شناسه تبلیغ در ویرگول', value: res.body.data.id },
          { title: 'وضعیت', value: res.body.data.status },
          { title: 'بودجه', value: res.body.data.budget },
          { title: 'بودجه باقی‌مانده', value: res.body.data.remainingBudget },
          {
            title: 'تاریخ ساخت',
            value: moment(res.body.data.createdAt).format('jYYYY-jMM-jDD HH:mm')
          },
          { title: 'total impressions', value: res.body.data.stats.totalImpressions },
          { title: 'clicks', value: res.body.data.stats.clicks },
          { title: 'impressions by date', value: res.body.data.stats.impressionsByDate },
          { title: 'last update', value: res.body.data.stats.lastUpdate }
        ]);
        setLoading(false);
      });
    } else {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchVirgoolAdData(virgoolId);
  }, []);

  if (loading) {
    return <Loading />;
  }

  const renderObject = obj => {
    for (const property in obj) {
      return `${property}: ${obj[property]}`;
    }
  };

  return (
    <div>
      {data &&
        data.map(item => (
          <div className="d-block w-50 border p-1 mb-1 rtl">
            <Title>{item.title}: </Title>
            {` `}
            <Value>{typeof item.value === 'object' ? renderObject(item.value) : item.value}</Value>
          </div>
        ))}
    </div>
  );
}

function VirgoolStatistics(props) {
  return (
    <Suspense fallback={<Loading />}>
      <Statistics {...props} />
    </Suspense>
  );
}

export default VirgoolStatistics;
